import { Injectable } from "@angular/core";
import { IMonitoringErrorsRepository } from "../../domain/monitoring/i-monitoring-errors-repository";
import { HttpService } from "../http/http";
import { MonitoringErrorDetails } from "../../domain/monitoring/monitoringErrorDetails";
import moment from "moment";

@Injectable()
export class MonitoringErrorsRepository implements IMonitoringErrorsRepository {
  constructor(private _httpService: HttpService) {}

  get(
    availabilityZoneIds: number[],
    errorIds: number[],
    channelIds: number[],
    fromDate: moment.Moment,
    toDate: moment.Moment,
    isActive: boolean | undefined,
  ): Promise<MonitoringErrorDetails[]> {
    const params = [];
    let availabilityZoneIdsParam = "availabilityZoneIdsParam=";
    if (availabilityZoneIds && availabilityZoneIds.length > 0) {
      availabilityZoneIdsParam += `${availabilityZoneIds.join(",")}`;
    }
    params.push(availabilityZoneIdsParam);

    let errorIdsParam = "errorIdsParam=";
    if (errorIds && errorIds.length > 0) {
      errorIdsParam += `${errorIds.join(",")}`;
    }
    params.push(errorIdsParam);

    let channelIdsParam = "channelIdsParam=";
    if (channelIds && channelIds.length > 0) {
      channelIdsParam += `${channelIds.join(",")}`;
    }
    params.push(channelIdsParam);

    let fromDateParam = "fromDateParam=";
    if (fromDate) {
      fromDateParam += `${fromDate.format("YYYYMMDD")}`;
    }
    params.push(fromDateParam);

    let toDateParam = "toDateParam=";
    if (toDate) {
      toDateParam += `${toDate.format("YYYYMMDD")}`;
    }
    params.push(toDateParam);

    let isActiveParam = "isActive=";
    if (isActive !== undefined) {
      isActiveParam += `${isActive}`;
    }
    params.push(isActiveParam);

    return this._httpService
      .get(`reports/GetMonitoringErrors?${params.join("&")}`)
      .then((result) =>
        result.map(
          (r) =>
            new MonitoringErrorDetails(
              r.Id,
              r.ErrorId,
              r.PlatformId,
              r.PlatformName,
              r.ChannelId,
              r.ChannelName,
              r.AvailabilityZoneId,
              r.AvaiabilityZoneName,
              r.Count,
              r.Severity,
              r.Msg,
              moment.utc(r.CreatedTime),
              r.ResolveTime ? moment.utc(r.ResolveTime) : null,
            ),
        ),
      );
  }
}
